<div class="dashboard-container">
    @defer {

    <div class="dashboard-toolbar">
        <button class="export-btn" [disabled]="isExporting" (click)="exportXlsx()">
            @if (isExporting) {
            <span class="export-spinner"></span>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            }
            {{ isExporting ? 'Exportando...' : 'Exportar datos' }}
        </button>
    </div>

    <div class="section-header">
        <h2>{{'DASHBOARD.RESULTS_TITLE' | translate}}</h2>
        <hr class="separator-line">
    </div>

    <!-- Scorecards -->
    <div class="scorecard-wrapper">
        <div class="scorecard">
            <h2>{{'DASHBOARD.TOTAL_RESPONSES' | translate}}</h2>
            <h1>{{getSurveysLength()}}</h1>
        </div>
        <div class="scorecard">
            <h2>{{'DASHBOARD.AVG_RATING' | translate}}</h2>
            <h1>{{averageSatisfaction | number:'1.1-1'}}<span class="scorecard-suffix"> / 5</span></h1>
        </div>
    </div>

    <!-- Origen -->
    <div class="divider"><span>{{'DASHBOARD.ORIGIN' | translate}}</span></div>

    <div class="origin-row">
        <app-doughnut-chart [title]="'DASHBOARD.NATIONALITY' | translate" [chartData]="nationalityData" [chartId]="'nationality'"
            [chartLabels]="nationalityLabels"
            [chartColors]="['#a8d8ea','#81c3d7','#62b6cb','#3a9fbf','#2589ad','#1b7a9e']"></app-doughnut-chart>
        <div class="ranking-card">
            <h3>{{'DASHBOARD.TOP_NATIONALITIES' | translate}}</h3>
            <div class="ranking-list">
                @for (item of nationalityRanking; track item.label; let i = $index) {
                <div class="ranking-item">
                    <span class="ranking-position">{{i + 1}}</span>
                    <span class="ranking-label">{{item.label}}</span>
                    <span class="ranking-count">{{item.count}}</span>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="origin-row">
        <app-doughnut-chart [title]="'DASHBOARD.RESIDENCE' | translate" [chartData]="residenceData" [chartId]="'residence'"
            [chartLabels]="residenceLabels"
            [chartColors]="['#b8d4e3','#92bdd4','#6da6c5','#4f92b5','#3a7fa6','#2a6d94']"></app-doughnut-chart>
        <div class="ranking-card">
            <h3>{{'DASHBOARD.TOP_RESIDENCES' | translate}}</h3>
            <div class="ranking-list">
                @for (item of residenceRanking; track item.label; let i = $index) {
                <div class="ranking-item">
                    <span class="ranking-position">{{i + 1}}</span>
                    <span class="ranking-label">{{item.label}}</span>
                    <span class="ranking-count">{{item.count}}</span>
                </div>
                }
            </div>
        </div>
    </div>

    <!-- Perfil demográfico -->
    <div class="divider"><span>{{'DASHBOARD.DEMOGRAPHIC' | translate}}</span></div>
    <div class="chart-row">
        <app-bar-chart [title]="'DASHBOARD.AGE' | translate" [chartData]="ageData" [chartId]="'age'" [chartLabels]="ageLabels"
            [barColor]="'rgba(186, 220, 168, 0.7)'" [barBorderColor]="'#8cc374'"></app-bar-chart>

        <app-doughnut-chart [title]="'DASHBOARD.GENDER' | translate" [chartData]="genderData" [chartId]="'gender'" [chartLabels]="genderLabels"
            [chartColors]="['#b5e6a3','#8cc374','#6aab57','#4e9340']"></app-doughnut-chart>

        <app-doughnut-chart [title]="'DASHBOARD.MARITAL_STATUS' | translate" [chartData]="maritalStatusData" [chartId]="'maritalStatus'"
            [chartLabels]="maritalStatusLabels"
            [chartColors]="['#c5e8b0','#9fd68c','#7ec46a','#5aad47']"></app-doughnut-chart>
    </div>

    <!-- Perfil socioeconómico -->
    <div class="divider"><span>{{'DASHBOARD.SOCIOECONOMIC' | translate}}</span></div>
    <div class="chart-row">
        <app-doughnut-chart [title]="'DASHBOARD.EMPLOYMENT' | translate" [chartData]="employmentStatusData"
            [chartId]="'employmentStatus'" [chartLabels]="employmentStatusLabels"
            [chartColors]="['#f0c4a8','#e8a882','#de8c5e','#d4713e']"></app-doughnut-chart>

        <app-bar-chart [title]="'DASHBOARD.SALARY_RANGE' | translate" [chartData]="salaryRangeData" [chartId]="'salaryRange'"
            [chartLabels]="salaryRangeLabels" [barColor]="'rgba(232, 168, 130, 0.7)'"
            [barBorderColor]="'#de8c5e'"></app-bar-chart>

        <app-doughnut-chart [title]="'DASHBOARD.VISIT_PURPOSE' | translate" [chartData]="visitPurposeData" [chartId]="'visitPurpose'"
            [chartLabels]="visitPurposeLabels"
            [chartColors]="['#f0c4a8','#e8a882','#de8c5e','#d4713e','#c45a2a','#b04a1e','#9a3b14']"></app-doughnut-chart>
    </div>

    <!-- Itinerario de la visita -->
    <div class="section-header section-separator">
        <h2>{{'DASHBOARD.ITINERARY_TITLE' | translate}}</h2>
        <hr class="separator-line">
    </div>

    <div class="binary-row">
        <div class="binary-card">
            <h3>{{'DASHBOARD.FIRST_FUERTEVENTURA' | translate}}</h3>
            <span class="binary-pct">{{firstTimeFuerteventura.pct}}%</span>
            <div class="binary-details">
                <span class="binary-yes">{{'DASHBOARD.YES' | translate}} {{firstTimeFuerteventura.yes}}</span>
                <span class="binary-no">{{'DASHBOARD.NO' | translate}} {{firstTimeFuerteventura.no}}</span>
            </div>
        </div>
        <div class="binary-card">
            <h3>{{'DASHBOARD.FIRST_OLIVA' | translate}}</h3>
            <span class="binary-pct">{{firstTimeLaOliva.pct}}%</span>
            <div class="binary-details">
                <span class="binary-yes">{{'DASHBOARD.YES' | translate}} {{firstTimeLaOliva.yes}}</span>
                <span class="binary-no">{{'DASHBOARD.NO' | translate}} {{firstTimeLaOliva.no}}</span>
            </div>
        </div>
    </div>

    <div class="wonders-section">
        <div class="wonders-chart">
            <app-bar-chart [title]="'DASHBOARD.WONDERS_VISITED' | translate" [chartData]="wondersData" [chartId]="'wonders'"
                [chartLabels]="wondersLabels" [barColor]="'rgba(252, 194, 0, 0.7)'"
                [barBorderColor]="'#fcc200'"></app-bar-chart>
        </div>
        <div class="wonder-profiles">
            @for (profile of wonderProfiles; track profile.wonder) {
            <div class="wonder-card">
                <h3>{{profile.wonder}}</h3>
                <div class="wonder-stats">
                    <div class="wonder-stat">
                        <span class="stat-value">{{profile.count}}</span>
                        <span class="stat-label">{{'DASHBOARD.VISITORS' | translate}}</span>
                    </div>
                    <div class="wonder-stat">
                        <span class="stat-value">{{profile.avgAge}}</span>
                        <span class="stat-label">{{'DASHBOARD.AVG_AGE' | translate}}</span>
                    </div>
                    <div class="wonder-stat">
                        <span class="stat-value">{{profile.avgSatisfaction}}</span>
                        <span class="stat-label">{{'DASHBOARD.RATING' | translate}}</span>
                    </div>
                    <div class="wonder-stat">
                        <span class="stat-value small">{{profile.topNationality}}</span>
                        <span class="stat-label">{{'DASHBOARD.NATIONALITY' | translate}}</span>
                    </div>
                    <div class="wonder-stat">
                        <span class="stat-value small">{{profile.topSalaryRange}}</span>
                        <span class="stat-label">{{'DASHBOARD.SALARY' | translate}}</span>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>

    }

    @loading (minimum 3s) {
    <div class="placeholder-container">
        <img src="../../../assets/images/logo_flor.png" class="image-loader-single" [attr.alt]="'DASHBOARD.LOADING' | translate">
        <p class="loading-text">{{'DASHBOARD.LOADING' | translate}}</p>
    </div>
    }

</div>